<div class="mmc-settings-asset-class-container">
    <div class="mmc-settings-asset-class-add-container">
        <div class="mmc-settings-asset-class-add-container-row">
            <div class="mmc-settings-asset-class-add-container-element">
                <div class="mmc-settings-asset-class-add-container-element-input">
                    <input type="text" pInputText [value]="assetClassName"
                           autocomplete="off"
                           autocorrect="off"
                           autocapitalize="off"
                           spellcheck="false"
                           placeholder="Enter an asset class"
                           [formControl]="assetClassValidationTextBoxInputControl"
                           [(ngModel)]="assetClassName"
                           tooltip
                           [tooltipTitle]="inputErrorMessage"
                           [tooltipPosition]="'right'"
                           tooltipClass="error"
                           [tooltipHorizontalOffset]="8"
                           maxlength="70"
                           #assetClassValidationTextBox>
                </div>
                <div class="mmc-settings-asset-class-add-container-element-button">
                    <button class="btn-medium-secondary btn-spacer" (click)="onAddAssetClass()"
                            [disabled]="(!assetClassValidationTextBoxInputControl?.valid ||  !assetClassName )">Add
                    </button>
                </div>
            </div>

        </div>
    </div>
    <div class="mmc-counter-label"> {{getNonDeletedCount() + ' Asset Classes'}}</div>
    <irb-inventory-grid
            class="mmc-settings-asset-class-grid-ag"
            [style.width]="'100%'"
            [gridHeight]="'240px'"
            [showSideBar]="false"
            [gridOptions]="gridOptions"
            [frameworkComponents]='frameworkComponents'
            [rowData]="data"
            (cellValueChanged)="onCellValueChanged($event)"
            (gridReady)="onGridReady($event)"></irb-inventory-grid>
</div>


